import { Button, Paper, Typography } from '@mui/material'
import React from 'react'

function Templates({onTemp1,onTemp2,onTemp3}) {
  return (
    <div>
        <Paper style={{display:'flex', justifyContent:'space-between', padding:'2rem'}}>
            <Typography>Custom Templates</Typography>
            <Button variant='contained' onClick={onTemp1}>View</Button>
        </Paper>
        <Paper style={{display:'flex', justifyContent:'space-between', padding:'2rem'}}>
            <Typography>Acknowledgement Templates</Typography>
            <Button variant='contained' onClick={onTemp2}>View</Button>
        </Paper>
        <Paper style={{display:'flex', justifyContent:'space-between', padding:'2rem'}}>
            <Typography>Feedback Templates</Typography>
            <Button variant='contained' onClick={onTemp3}>View</Button>
        </Paper>
    </div>
  )
}

export default Templates